import * as Sentry from '@sentry/react';
import { analyticsEventsTracker, EVENT_TRACKERS } from '../analytics';

interface PaymentErrorOptions {
  provider: 'paypal' | 'stripe';
  stage: string;
  errorName: string;
  message: string;
  extra?: Record<string, any>;
}

export function capturePaymentError({
  provider,
  stage,
  errorName,
  message,
  extra,
}: PaymentErrorOptions) {
  const error = new Error(message);
  error.name = errorName;

  if (Math.random() < 0.1) {
    Sentry.withScope((scope) => {
      scope.setTag('module', 'payment');
      scope.setTag('provider', provider);
      scope.setTag('stage', stage);

      scope.setFingerprint(['payment', provider, stage, errorName]);

      if (extra) {
        Object.entries(extra).forEach(([key, value]) => {
          scope.setExtra(key, value);
        });
      }

      Sentry.captureException(error);
    });
  }

  analyticsEventsTracker.trackWithTarget(
    {
      name: 'payment_error',
      info: {
        provider,
        stage,
        error_name: errorName,
        ...extra,
      }
      
    },
    EVENT_TRACKERS.GTM
  );

  window.dataLayer?.push({
    event: 'payment_error',
    provider,
    stage,
    error_name: errorName,
    ...extra,
  });
}